<template>
  <div class="about">
    <b-container >
		<b-row>
             <b-col class="text-center">
            <router-link to="/">Home</router-link> |
            <router-link to="/viewUnresolvedJobs">View Jobs</router-link> |
            <router-link to="/viewResolvetickets">View Tickets</router-link> |
            <router-link to="/createTicket">Create Tickets</router-link> 
            <br>
            <br>
            </b-col>
        </b-row>
        <b-row>
         <b-col class="text-center">
            <img src="img/logo.png" class="center-block" alt="EnergyDrive">
            </b-col>
        </b-row>
        <b-row>
         <b-col class="text-center">
            <br>
            </b-col>
        </b-row>
		<b-row >
             <b-col class="text-left">
        </b-col>
		</b-row>
        <b-row>
            <b-col>
                <br>
            </b-col>
        </b-row>
		<b-row v-if="adminRights">
			<hr>		
            <b-col class="text-left" sm="12" lg="6">
                <b >View logged timesheet data for :</b>   
            </b-col>
            <b-col  sm="12" lg="6">
                <select class="form-control"  v-model="adminSelectedUser" style="overflow:scroll;" @change="getNewUserData" >
                    <option disabled selected value="-1"> -- Select a Employee -- </option>
                    <option v-for="user in users"  v-bind:key="user.idEmployee" :value="user.idEmployee" >{{user.employee}}</option>
                   
                </select>
           </b-col>
           <br d-lg-none ><br d-lg-none >
            <!--<b-col sm="12" lg="4">
                <button class="btn btn-primary w-100" @click="showTimeSlots = !showTimeSlots">(Show/hide)</button>      
            </b-col>-->
        </b-row >
        <br><br>
        <div  v-if="showTimeSlots">
            <b-tabs content-class="mt-2"  v-model="selectedTab">
                <br>
            <b-tab title="Create timesheet entry"  >
                <b-row >
                    <hr>		
                    <b-col class="text-left" >
                        <b>Insert Hours / Milage for :</b>
                        <br><br>
                        <select class="form-control"  v-model="selectedUser" style="overflow:scroll;" @change="getNewUserData">
                            <option disabled selected value="-1"> -- Select a Employee -- </option>
                            <option v-for="user in users"  v-bind:key="user.idEmployee" :value="user.idEmployee" >{{user.employee}}</option>
                        
                        </select>
                    
                        
                    </b-col>
                    
                </b-row>
                <br>
                <b-row v-if="gotticketsSearch">
                    <hr>		
                    <b-col class="text-left" >
                       
                        <b-form-input v-model="searchField" placeholder="Search for a ticket"></b-form-input>
                        <select class="form-control"  v-model="selectedSearchTicket" style="overflow:scroll;" v-if="searchTicket.length > 0" @change="selectSearchTicketMethod">
                            <option disabled selected value="-1">Tickets found ...</option>
                            <option v-for="ticket in searchTicket"  v-bind:key="ticket.idTicket" :value="ticket.idTicket" >{{ticket.idTicket}} - {{ticket.Description}}</option>
                        
                        </select>
                    </b-col>
                    
                </b-row>

                <br>
                <b-row>        
                    <b-col class="text-left"  sm="12" lg="3">
                        <b>Site</b><br>
                        <select class="form-control"  v-model="selectSite" style="overflow:scroll;" @change="siteChanged" >
                            <option disabled selected value="-1"> -- Select a site -- </option>
                        <option v-for="site in sites"  v-bind:key="site.idSite" :value="site.idSite" >{{site.SiteName}}</option>
                        
                        </select><br>
                    </b-col>
                    <b-col class="text-left"  sm="12" lg="3">
                            <b>Stage of work</b><br>
                            <select :disabled="disableSelectStageWork" class="form-control"   v-model="selectedStage" style="overflow:scroll;"  @change="stageWorkChanged">
                                <option selected value="-1"> -- Select stage of work -- </option>
                                <option v-for="dep in departmentsList"  v-bind:key="dep.idDepartment" :value="dep.idDepartment" >{{dep.Name}}</option>
                            </select><br>
                        </b-col>
                    <b-col class="text-left"  sm="12" lg="3">
                            <b>Category</b><br>
                            <select :disabled="disableSelectCategory" class="form-control" v-model="selectedCategory"  style="overflow:scroll;" @change="categoryChanged">
                                <option selected value="-1"> -- Select category -- </option>
                                <option v-for="cat in filteredCategory"  v-bind:key="cat.idTicketCategory" :value="cat.idTicketCategory" >{{cat.CategoryName}}</option>
                            </select><br>
                        </b-col>
                    <b-col class="text-left"  sm="12" lg="3">
                        <b>Sub Category</b><br>
                        <select :disabled="disableSelectSubCategory" class="form-control"  v-model="selectedSubCategory" style="overflow:scroll;" @change="subCategoryChanged">
                            <option selected value="-1"> Filter by sub category</option>
                            <option v-for="sub in subCategoryList"  v-bind:key="sub.idTicketSubCategory" :value="sub.idTicketSubCategory" >{{sub.Name}} [{{sub.count}}]</option>
                        </select><br>
                    </b-col> 
                </b-row>
                <br>
                <div v-if="showTicketsSelect&&(filteredTickets.length>0)">
                    <b-row >
                        <b-col class="text-left">
                            <b>Select Ticket</b><br>
                            <select class="form-control mb-8"  v-model="selectedticket"  @change="ticketChange" ref="ticketSelect" id="element">
                                <option disabled selected value="-1"> Select Ticket to log time to </option>
                                <option disabled selected value="-2" v-if="loadingTickets" style="width:100px">Loading Tickets ...  </option>
                                
                                <option v-for="ticket in filteredTickets"  v-bind:key="ticket.idTicket" :value="ticket.idTicket">#{{ticket.idTicket}} - {{ticket.TicketIssued}} - {{ticket.ShortDesc}}</option>
                            
                            </select>
                        
                        </b-col>
                                
                    </b-row>
                    <br>
                    <b-row v-if="currentTicket != 'None'">
                        <b-col class="text-left">
                            <b>Ticket#</b> {{currentTicket.idTicket}}  <b-btn v-b-toggle="'collapse2'" class="m-1">View ticket Details</b-btn>

                        </b-col >       
                    </b-row>
                    <br>
                    <b-collapse id="collapse2" class="text-left" v-if="currentTicket != 'None'">
                        <b-card>
                            <b>Created Date : </b>{{currentTicket.CreatedDate[0]}} <br>
                            <b>Created by : </b>{{currentTicket.CreatedBy[0]}} <br>
                            <b>Full Description : </b>{{currentTicket.Description[0]}} <br>
                        
                        </b-card>
                    </b-collapse>
                    <br>
                </div>
                <div v-if="loadingTickets">
                    <b-row>
                        <b-col >
                        <b>BUSY LOADING TICKETS</b> <img src="img/small.gif" class="center-block" alt="...">
                        </b-col >
                    </b-row>   
                </div> 
            
                <div v-if="(filteredTickets.length == 0)&&(!loadingTickets)">
                    <b-row>
                        <b-col >
                        <b>{{displayText}}</b>
                        </b-col >
                    </b-row>   
                </div>    
                <b-row v-if="showCommentSelect&&(filteredTickets.length>0)&&(selectedticket>0)">
                
                    <b-col class="text-left">
                        <b>Select a comment</b><br>
                        <select class="form-control"  v-model="selectedComment" style="overflow:scroll;" @change="selectedCommentChange">
                            <option disabled selected value="-1"> -- Select comment [{{commentLength}}] / or new comment-- </option>
                            <option  selected value="-2">Create a new comment</option>
                            <option v-for="comment in selectedTicketComments"  v-bind:key="comment.idTicketHistory" :value="comment.idTicketHistory" >{{comment.CreatedDate}} - {{comment.Comment}}</option>
                        
                        </select>
                    </b-col>
                </b-row>
                <br>
                <b-row v-if="createComment&&(filteredTickets.length>0)">
                
                    <b-col class="text-left"  sm="12" lg="6">
                    Comment
                    </b-col>
                    <b-col  sm="12" lg="6">
                        <input  type="text" name="tagInfo" class="form-control" v-model="comment"/>
                    </b-col>
                
                
                </b-row>   
                <br>
                <div v-if="showHoursMileageInput&&(filteredTickets.length>0)">
                    <b-row >
                        <b-col class="text-left"  sm="12" lg="3">
                            Actual Date 
                        </b-col>
                        <b-col class="text-left"  sm="12" lg="3">
                            <datetime v-model="ActualDate" style="border-radius: 4px;"></datetime>
                        </b-col><br><br>
                        <b-col class="text-left"  sm="12" lg="3">Type of Timesheet Entry</b-col>  
                        <b-col class="text-left"  sm="12" lg="3"><select class="form-control"  v-model="selectedTagType" style="overflow:scroll;" >
                                <option value="1">PROJECT ( P4 -> C4 )</option>
                                <option value="5">MAINTENANCE ( After C4 )</option>
                                <option value="6">GENERAL</option>
                            </select>
                        </b-col>  
                        
                    
                    </b-row>
                    <br>
                    <b-row >
                        <b-col class="text-left"  sm="12" lg="3">
                            Hours
                        </b-col>  
                        <b-col class="text-left"  sm="12" lg="3">
                            <input  type="text"  class="form-control" v-model="nrHours"/>
                        </b-col>
                        
                        <b-col class="text-left"  sm="12" lg="3">Mileage</b-col>  
                        <b-col class="text-left"  sm="12" lg="3"> <input  type="text"  class="form-control" v-model="nrMiles"/></b-col>  
                        </b-row>
                    <br>
                </div>
                <br>
                <b-row v-if="showLogButton">
                    <b-col >
                    <button class="btn btn-primary w-100" @click="logTimeSheet">Log Timesheet </button>
                    </b-col>
                </b-row>  

            </b-tab>
            <b-tab title="View all hours/mileage" ><br><component-viewtagtable :idemployee="idEmployee" :nrdays="nrDaysTagsToGet" :admin="adminRights"></component-viewtagtable></b-tab>
            <b-tab title="View Week Summary" ><br><component-viewTagSummaryTable :idemployee="idEmployee" > </component-viewTagSummaryTable></b-tab>
            <b-tab title="View my Tickets/Jobs" ><br><component-ViewMyTickets :idemployee="idEmployee" ></component-ViewMyTickets></b-tab>
            <b-tab title="View / Create Leave Request" ><br><component-ViewMyLeave :idemployee="idEmployee" ></component-ViewMyLeave></b-tab>
            
            <!--<component-viewTagSummaryTable :idemployee="idEmployee" :weekstart="weekStart" :weekend="weekEnd"> </component-viewTagSummaryTable>-->
            <!--<component-viewtagtable :idemployee="idEmployee" :nrdays="nrDaysTagsToGet" :admin="adminRights"></component-viewtagtable> -->
            </b-tabs>
            <br><br>
        </div>
       
        
   
         
         
    </b-container>    
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import viewTagTable from '../components/ViewTagTable.vue'
import ViewMyTickets from '../components/ViewMyTickets.vue'
import ViewMyLeave from '../components/ViewMyLeave.vue'
import viewTagSummaryTable from '../components/ViewTagSummaryTable.vue'
import EventBus from '../eventBus'

export default {
  name: 'viewMyJobs',
 
   components: {
       'component-viewtagtable' : viewTagTable,
       'component-viewTagSummaryTable' : viewTagSummaryTable,
       'component-ViewMyTickets' : ViewMyTickets,
    'component-ViewMyLeave' : ViewMyLeave
  
   },
  data: () => ({
        timeSlots : [],
        disableSelectStageWork : true,
        disableSelectCategory  : true,
        disableSelectSubCategory : true,
        searchField : "",
        idEmployee : null,
        Employee : null,
        showTimeSlots : true,
        selectSite : -1,
        users : null,
        selectedUser : null,
        adminSelectedUser : null,
        adminRights : false,
        sites : null,
        comment : "",
        commentLength : 0,
        hasComment : false,
        ActualDate : null,
        loadingTickets : false,
        displayText : "",
        departmentsList : [],
        categoryList : [],
        subCategoryList : [],
        tickets : [],
        showTicketsSelect : false,
        showCommentSelect : false,
        showHoursMileageInput : false,
        showLogButton : false,
        selectedTicket : 0,
        selectedStage : -1,
        selectedCategory : -1,
        selectedSubCategory : -1,
        selectedticket : -1,
        selectTicketWidth : 0,
        ticketduedate : null,
        selectedComment : -1,
        selectedTagType : "5",
        createComment : false,
        logger : "",
        showLoader : true,
        showNoTickets : false,
        nrHours : 0,
        nrMiles : 0,
        nrDaysTagsToGet : 10000,
        gotticketsSearch : false,
        searchTicketList : [],
        selectedSearchTicket : -1,
        showSearchTicket : false,
        selectedTab : 0,
        
        viewticket : 0,
        whichMenu : 1,
        //searchTicket : null
  }),
 methods: {
        submit : function() {
            console.log("Submit");
        },
        cancel : function() {
            console.log("Cancel");
        },

        selectSearchTicketMethod : function()
        {
            console.log(this.selectedSearchTicket);
            this.getTicket(this.selectedSearchTicket,-1);
        },
        siteChanged : function() {
            
            var mainObject = this;
            mainObject.selectedComment = -1;
            
            // Allow user to choose stage of work
            mainObject.disableSelectStageWork = false;
            mainObject.showLogButton = false;
            mainObject.showCommentSelect = false;
            mainObject.showHoursMileageInput = false;
            mainObject.selectedticket = -2;
            mainObject.selectedCategory = -1;
            mainObject.selectedSubCategory = -1;
            mainObject.selectedStage = -1;
            mainObject.subCategoryList = [];
            mainObject.tickets = [];

            

        },
        stageWorkChanged : function() {
            this.disableSelectCategory = false;
            this.selectedCategory = -1;
            this.selectedSubCategory = -1;
            this.subCategoryList = [];
            this.tickets = [];
            this.displayText = "";
            this.showLogButton = false;
            this.showCommentSelect = false;
            this.showHoursMileageInput = false;

        },

        categoryChanged : function() {
            
            let mainObject = this;
            mainObject.disableSelectSubCategory = false;
            mainObject.showTicketsSelect = true;
            mainObject.selectedSubCategory = -1;    
            mainObject.showLogButton = false;
            mainObject.showCommentSelect = false;
            mainObject.showHoursMileageInput = false;
            // This need to happen only when category changes
            axios.get(localStorage.getItem('ticketCopURL') +'/getSubCategories', {
            params: {
                    idTicketCategory : mainObject.selectedCategory
            },
             headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
                //console.log(response);
                //console.log("getting tickets.."+response.data.length);
                if ( response.data != "error" )
                {
                    for( var i = 0 ; i < response.data.length ;i++ )
                    {
                        response.data[i].count = 0;
                    }
                    mainObject.subCategoryList = response.data;
                    if ( mainObject.subCategoryList.length == 1 )
                    {
                        mainObject.selectedSubCategory = mainObject.subCategoryList[0].idTicketSubCategory;
                    }
                 
                }
                
                
                //mainObject.ticketTagSubCategory_visible = true;

                })
                .catch(function () {
                //console.log(error);
                })
                .then(function () {
            })
            // END OF AXIOS Call to get sub catgegories
            
            // CALL To get all tickets for site and department
            mainObject.loadingTickets = true;
            axios.get(localStorage.getItem('ticketCopURL') +'/viewSelectedTickets', {
            params: {
                    idTicketCategory : mainObject.selectedCategory,
                    idSite : mainObject.selectSite
            },
             headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
                //console.log(response.data);
                //console.log("getting tickets.."+response.data.length);
                if ( response.data != "error" && response.data.length > 0)
                {
                    response.data.forEach(ticket => {
                        //console.log(ticket.Description[0]);
                        let length = 100;
                        if ( ticket.Description[0].length > length )
                            ticket.ShortDesc =  ticket.Description[0].substring(0, length-3)+"...";
                        else
                            ticket.ShortDesc = ticket.Description[0];
                        for( var i = 0 ; i < mainObject.subCategoryList.length ;i++ )
                        {
                            if ( ticket.idTicketSubCategory == mainObject.subCategoryList[i].idTicketSubCategory )
                            {
                                mainObject.subCategoryList[i].count++;

                            }
                        }
                        //console.log("Done with"+ticket.idTicket);
                    });
                    // console.log("Done tickets..");
                    mainObject.tickets = response.data;
                    mainObject.selectedticket = -1;
                    mainObject.selectTicketWidth = mainObject.$refs.ticketSelect.clientWidth;
                    mainObject.loadingTickets = false;
                }
                else
                {
                    console.log("Error or no tickets here");
                    mainObject.tickets = [];
                    mainObject.displayText = "NO TICKETS UNDER THIS CATEGORY";
                    setTimeout( function() {
                        mainObject.loadingTickets = false;
                    },2000);
                }

                
                //mainObject.ticketTagSubCategory_visible = true;

                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    console.log("Got all tickets ");
                      mainObject.loadingTickets = false;
            })
            // END OF AXIOS Call*/
            
        },
        subCategoryChanged : function()
        {
            this.selectedticket = -1;
            this.showHoursMileageInput = false;
            this.showCommentSelect = false;
            this.showHoursMileageInput = false;
        },

        

        getTicket : function(idTicket,idComment) {
            console.log("Calling get ticket method from child");
            console.log(idComment);
            this.selectedTab = 0;
            var mainObject = this;
            mainObject.tickets = [];
            mainObject.selectedComment = -1;
           
            mainObject.loadingTickets = true;
            mainObject.selectedticket = -2;
            //mainObject.selectTicketWidth = mainObject.$refs.ticketSelect.clientWidth;
            //console.log(mainObject.$refs.ticketSelect);
            //console.log(mainObject.$refs.ticketSelect.clientWidth);

            //console.log("siteChanged");
            axios.get(localStorage.getItem('ticketCopURL') +'/viewSpecificTicket', {
            params: {
                    idTicket : idTicket
            },
             headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
                //console.log(response);
                console.log("getting tickets.."+response.data.length);
                if ( response.data != "error" )
                response.data.forEach(ticket => {
                    //console.log(ticket.Description[0]);
                    let length = 100;
                    if ( ticket.Description[0].length > length )
                        ticket.ShortDesc =  ticket.Description[0].substring(0, length-3)+"...";
                    else
                        ticket.ShortDesc = ticket.Description[0];
                    //console.log("Done with"+ticket.idTicket);
                });
                console.log("Done tickets..");
                console.log(response.data);

                mainObject.tickets = response.data;
                if ( response.data.length > 0 )
                {
                    
                    mainObject.selectSite = response.data[0].idSite;
                    mainObject.selectedStage = response.data[0].Department;
                    mainObject.selectedCategory = response.data[0].TicketCategory;
                    mainObject.selectedSubCategory = -1;

                    mainObject.selectedticket = idTicket;
                   
                    mainObject.loadingTickets = false;
                    mainObject.showTicketsSelect = true;
                    mainObject.ticketChange();
                    mainObject.selectedComment = idComment;
                    if (response.data[0].isSite )
                        mainObject.selectedTicket = 1;
                    else
                         mainObject.selectedTicket = 0;
                    mainObject.disableSelectStageWork = true;
                    mainObject.disableSelectCategory = true;
                     mainObject.disableSelectSubCategory = true;
                     mainObject.showLogButton = true;
                    /*
                    axios.get(localStorage.getItem('ticketCopURL') +'/viewSelectfilteredTickets', {
                    params: {
                            idSite : mainObject.selectSite
                    },
                    headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
                    })
                    .then(function (response) {
                        //console.log(response);
                        //console.log("getting tickets.."+response.data.length);
                        if ( response.data != "error" )
                        response.data.forEach(ticket => {
                            //console.log(ticket.Description[0]);
                            let length = 100;
                            if ( ticket.Description[0].length > length )
                                ticket.ShortDesc =  ticket.Description[0].substring(0, length-3)+"...";
                            else
                                ticket.ShortDesc = ticket.Description[0];
                            //console.log("Done with"+ticket.idTicket);
                        });
                        // console.log("Done tickets..");
                        mainObject.tickets = response.data;
                        mainObject.selectedticket = idTicket;
                        mainObject.loadingTickets = false;
                        
                        //mainObject.ticketTagSubCategory_visible = true;

                        })
                        .catch(function () {
                        //console.log(error);
                        })
                        .then(function () {
                    })*/
                }
                else
                {
                     mainObject.selectedticket = -1

                }
                //mainObject.selectedticket = -1
                mainObject.loadingTickets = false;
                
                //mainObject.ticketTagSubCategory_visible = true;

                })
                .catch(function () {
                //console.log(error);
                })
                .then(function () {
                })

        },
        ticketChange : function() {
            
            var mainObject = this;
            mainObject.selectedComment = -1;
            mainObject.createComment = false;
            mainObject.selectedComment == -1;
            mainObject.showCommentSelect = true;
            mainObject.showHoursMileageInput = true;
            // select Type of timesheet entry based on stage of work
            switch( mainObject.selectedStage )
            {
                case 5  :
                case 7  : 
                case 11 :           mainObject.selectedTagType = "6"; // project
                                     break;
                case 2 :              mainObject.selectedTagType = "5"; // Maintenace
                                     break;
                                    
            }
           
           
           

        },
        selectedCommentChange : function() {
            
            var mainObject = this;
            if ( mainObject.selectedComment == -2 )
                mainObject.createComment = true;
            else
                mainObject.createComment = false;
            mainObject.showLogButton = true;
            

        },
        logTimeSheet : function()
        {
            let mainObject = this;
            let validObject = true;
            switch(true)
            {
                case  ( mainObject.selectSite < 0 ) :
                    validObject = false;
                    mainObject.showAlert("Please select a site.",2000,false,"error",false);
                    break;
                case  ( mainObject.selectedticket < 0 ) :
                    validObject = false;
                    mainObject.showAlert("Please select a ticket.",2000,false,"error",false);
                    break;
                case  ( mainObject.selectedComment == -1 ) :
                    validObject = false;
                    mainObject.showAlert("Please select a comment or add a new comment.",2000,false,"error",false);
                    break;
                case  ( (mainObject.selectedComment == -2)&&(mainObject.comment.length == 0) ) :
                    validObject = false;
                    mainObject.showAlert("Comment value cannot be empty.",2000,false,"error",false);
                    break;
                case  ( (mainObject.nrHours == 0)&&(mainObject.nrMiles == 0) ) :
                    validObject = false;
                    mainObject.showAlert("Hours and milage cannot both be zero.",2000,false,"error",false);
                    break;
                case  ( isNaN(mainObject.nrHours)  ) :
                    validObject = false;
                    mainObject.showAlert("Hours must be a valid number.",2000,false,"error",false);
                    break;
                case  ( isNaN(mainObject.nrMiles)  ) :
                    validObject = false;
                    mainObject.showAlert("Milage must be a valid number.",2000,false,"error",false);
                    break;
                case  ( (mainObject.nrHours == "")&&(mainObject.nrMiles == "") ) :
                    validObject = false;
                    mainObject.showAlert("Hours and milage cannot both be empty.",2000,false,"error",false);
                    break;
                
                

               
            }
            if ( validObject )
            {
                
                let mainObject = this;
                console.log(mainObject.comment);
                let commentToShow = mainObject.comment;
                if ( mainObject.selectedComment > 0 )
                {
                    for( let i = 0 ; i < mainObject.selectedTicketComments.length; i++ )
                    {
                        if ( mainObject.selectedComment ==  mainObject.selectedTicketComments[i].idTicketHistory )
                        {
                            commentToShow = mainObject.selectedTicketComments[i].Comment;
                            break;
                        }
                    }
                   
                }
                mainObject.$swal({
                title: '<strong>Summary</strong>',
                type: 'info',
                html:
                    '<b>Hours  :</b> ' +mainObject.nrHours+'<br>'+
                    '<b>Milage :</b> ' +mainObject.nrMiles+'<br>'+
                    '<b>Actual Date :</b> ' +moment(mainObject.ActualDate).format('YYYY-MM-DD')+'<br>'+
                    '<b>Comment :</b> ' +commentToShow+'<br>'+
                    '<b>Logged For :</b> ' +mainObject.selectedEmployee.employee+'<br>'
                   ,
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText:
                    'Log Hours/Milage',
                confirmButtonAriaLabel: 'Ok',
                cancelButtonText:
                    'Cancel',
                cancelButtonAriaLabel: 'Cancel',
                }).then((result) => {
                    if (result.value)
                    {
                        console.log("Insert tags");
                        // create the tags that needs to be add
                        var tagsToAdd = [];
                        if ( mainObject.nrHours > 0 )
                        {
                            let tagObject = new Object;
                            tagObject.category = new Object;
                            tagObject.subcategory = new Object;
                            //tagObject.subcategory = //subcategory.idTicketTagSubCategory subcategory.Type subcategory.hasData 
                           // tagObject.description = 
                            tagObject.employee = mainObject.selectedEmployee.idEmployee;
                            tagObject.logger = mainObject.logger;
                            tagObject.tagDate = mainObject.ActualDate;
                            tagObject.value = mainObject.nrHours;
                           
                            //mainObject.selectedTagTyp = parseInt(mainObject.selectedTagTyp);
                            // slect correct categhory and subcategory of tasks
                            switch (mainObject.selectedTagType ) 
                            {
                                case "1" :    tagObject.category.idTicketTagCategory = 1;
                                            tagObject.subcategory.idTicketTagSubCategory = 1;
                                            tagObject.subcategory.hasData = 1;
                                           
                                            tagObject.subcategory.Type = "FLOAT";
                                            break;
                                case "5" :    tagObject.category.idTicketTagCategory = 5;
                                            tagObject.subcategory.idTicketTagSubCategory = 7;
                                            tagObject.subcategory.hasData = 1;
                                            tagObject.subcategory.Type = "FLOAT";
                                            break;
                                case "6" :    tagObject.category.idTicketTagCategory = 6;
                                            tagObject.subcategory.idTicketTagSubCategory = 10;
                                            tagObject.subcategory.hasData = 1;
                                            tagObject.subcategory.Type = "FLOAT";
                                            break;
                                default :   tagObject.category.idTicketTagCategory = 1;
                                            tagObject.subcategory.idTicketTagSubCategory = 1;
                                            tagObject.subcategory.hasData = 1;
                                           
                                            tagObject.subcategory.Type = "FLOAT";
                            }
                            tagObject.description =  mainObject.selectedEmployee.employee+" | HOURS | "+mainObject.nrHours;

                            // add hour tag
                            tagsToAdd.push(tagObject);
                        }
                        if ( mainObject.nrMiles > 0 )
                        {
                            let tagObject = new Object;
                            tagObject.category = new Object;
                            tagObject.subcategory = new Object;
                            //tagObject.subcategory = //subcategory.idTicketTagSubCategory subcategory.Type subcategory.hasData 
                           // tagObject.description = 
                            tagObject.employee = mainObject.selectedEmployee.idEmployee;
                            tagObject.logger = mainObject.logger;
                            tagObject.tagDate = mainObject.ActualDate;
                            tagObject.value = mainObject.nrMiles;
                            tagObject.description = "";//todo generate desc
                            //mainObject.selectedTagTyp = parseInt(mainObject.selectedTagTyp);
                            // slect correct categhory and subcategory of tasks
                            switch (mainObject.selectedTagType ) 
                            {
                                case "1" :    tagObject.category.idTicketTagCategory = 1;
                                            tagObject.subcategory.idTicketTagSubCategory = 2;
                                            tagObject.subcategory.hasData = 1;
                                            tagObject.subcategory.Type = "FLOAT";
                                            break;
                                case "5" :    tagObject.category.idTicketTagCategory = 5;
                                            tagObject.subcategory.idTicketTagSubCategory = 8;
                                            tagObject.subcategory.hasData = 1;
                                            tagObject.subcategory.Type = "FLOAT";
                                            break;
                                case "6" :    tagObject.category.idTicketTagCategory = 6;
                                            tagObject.subcategory.idTicketTagSubCategory = 11;
                                            tagObject.subcategory.hasData = 1;
                                            tagObject.subcategory.Type = "FLOAT";
                                            break;
                                default :   tagObject.category.idTicketTagCategory = 1;
                                            tagObject.subcategory.idTicketTagSubCategory = 2;
                                            tagObject.subcategory.hasData = 1;
                                           
                                            tagObject.subcategory.Type = "FLOAT";
                            }
                            tagObject.description =  mainObject.selectedEmployee.employee+" | MILEAGE  | "+mainObject.nrMiles;

                            // add hour tag
                            tagsToAdd.push(tagObject);
                            // add milage tag
                        }
                        console.log("tagsToAdd");
                        console.log(tagsToAdd);

                        // Case when its is a new comment so comment have to be created as well as the tags
                        if ( mainObject.selectedComment == -2 )
                        {
                            console.log("New comment required");
                           
                            axios.post(localStorage.getItem('ticketCopURL') +'/insertTicketComment', {
                                
                                    idEmployee : mainObject.idEmployee,
                                    idTicket : mainObject.currentTicket.idTicket,
                                    comment : mainObject.comment,
                                    supplies: mainObject.currentTicket.Supplies,
                                    Reason : mainObject.currentTicket.Reason,   
                                    employee : mainObject.logger,
                                    addedTags : tagsToAdd,
                                    createNewComment : true},{
                                    headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }

                                }
                                )
                                .then(function (response) {
                                    if ( response.data != "error" )
                                    {
                                        //mainObject.showAlert("Timesheet was logged.",2000,false,"info",true);
                                        mainObject.$swal({
                                            title: '',
                                            text: "Timesheet was logged",
                                            type: 'info',
                                            showCancelButton: true,
                                            confirmButtonColor: '#3085d6',
                                            cancelButtonColor: '#d33',
                                            confirmButtonText: 'Load another timesheet ?'
                                            }).then((result) => {
                                            if (result.value) 
                                            {
                                                console.log("Do nothing ticket #"+mainObject.currentTicket.idTicket);
                                                mainObject.comment = "";
                                               
                                                mainObject.getNewTicketsSetActiveTicket(mainObject.currentTicket.idTicket);
                                                

                                            }
                                            else
                                            {
                                                 mainObject.$router.go(-1);
                                                 

                                            }
                                            });

                                    }
                                    else
                                    {
                                        mainObject.showAlert("Error could not timesheet.",2000,false,"error",false);
                                    }
                                })
                                .catch(function (error) {
                                    console.log(error);
                                    console.log("Error in axios call");
                                    mainObject.showAlert("Error could not timesheet.",2000,false,"error",false);
                                })
                                .then(function () { 
                                // always executed
                                //console.log("Made request axios ticket to get sites");
                                mainObject.showLoader = false;
                                EventBus.$emit('RELOAD_SUMMARY_TABLE', "None");
                            }) // end of axios
                        }
                        else
                        {
                            axios.post(localStorage.getItem('ticketCopURL') +'/insertTicketComment', {
                                
                                    idEmployee : mainObject.idEmployee,
                                    idTicket : mainObject.currentTicket.idTicket,
                                    comment : mainObject.comment,
                                    supplies: mainObject.currentTicket.Supplies,
                                    Reason : mainObject.currentTicket.Reason,   
                                    employee : mainObject.logger,
                                    addedTags : tagsToAdd,
                                    createNewComment : false,
                                    idTicketComment : mainObject.selectedComment},{
                                    headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
                                
                                })
                                .then(function (response) {
                                //console.log(response);
                                if ( response.data != "error" )
                                {
                                    //mainObject.showAlert("Timesheet was logged.",2000,false,"info",true);
                                    mainObject.$swal({
                                            title: '',
                                            text: "Timesheet was logged",
                                            type: 'info',
                                            showCancelButton: true,
                                            confirmButtonColor: '#3085d6',
                                            cancelButtonColor: '#d33',
                                            confirmButtonText: 'Click to load another timesheet',
                                            cancelButtonText:  'Return to Home'
                                            }).then((result) => {
                                            if (result.value) 
                                            {
                                                console.log("Do nothing");
                                                //mainObject.comment = "";
                                                //mainObject.selectedticket = -1;
                                                //mainObject.getNewTicketsSetActiveTicket(mainObject.currentTicket.idTicket);
                                                

                                            }
                                            else
                                            {
                                                 mainObject.$router.go(-1);
                                                 //to do must reload ticket comments

                                            }
                                            });
                                }
                                else
                                {
                                    mainObject.showAlert("Error could not timesheet.",2000,false,"error",false);
                                }
                                //mainObject.sites = response.data;
                                console.log(response.data);
                                
                                //mainObject.ticketTagSubCategory_visible = true;

                                })
                                .catch(function (error) {
                                    console.log(error);
                                     mainObject.showAlert("Error could not timesheet.",2000,false,"error",false);
                                })
                                .then(function () {
                                // always executed
                                //console.log("Made request axios ticket to get sites");
                                mainObject.showLoader = false;
                                EventBus.$emit('RELOAD_SUMMARY_TABLE', "None");

                            }); // end of axios
                        }
                    }

                    
                })
               // })
            }
            else
            {
                console.log("Invalid object");
                
            }

        },

        showAlert : function (msg,delay,gotoprevPage,type,reloadPage)
        {
            let timerInterval;
            let mainObject = this;
            mainObject.$swal({
            //title: 'Auto close alert!',
            html: msg,
            type: type,
            timer: delay,
            onBeforeOpen: () => {
                mainObject.$swal.showLoading()
                timerInterval = setInterval(() => {
                mainObject.$swal.getContent().querySelector('strong')
                    
                }, 100)
            },
            onClose: () => {
                clearInterval(timerInterval)
            }
            }).then((result) => {
            if (
                // Read more about handling dismissals
                result.dismiss === mainObject.$swal.DismissReason.timer
            ) {
                if ( gotoprevPage )
                mainObject.$router.go(-1);
                if (reloadPage)
                 mainObject.$router.go(0);
            }
            })  
        },
        getNewUserData : function()
        {
            console.log("Getting new data");

            let mainObject = this;
            mainObject.showTimeSlots = false;
            setTimeout(() => {
                mainObject.showTimeSlots = true;
            }, 500); 
            let sinceDate = moment().subtract(mainObject.nrDaysTagsToGet,'days').format('YYYY-MM-DD');
            
            axios.get(localStorage.getItem('ticketCopURL') +'/getTagsEmployee', {
            params: {
                idEmployee : mainObject.adminSelectedUser,
                sinceDate : sinceDate

            },
             headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
            //console.log(response);
            if ( response.data != "error" )
            //mainObject.sites = response.data;
            response.data.forEach(el => {
                mainObject.timeSlots.push({ Date : el.ActualDate , TicketDescription : el.TicketDescription, TagCategory : el.TagCategory,TagSubCategory : el.TagSubCategory,Value : el.valueAny });
            });
            
            //mainObject.ticketTagSubCategory_visible = true;

            })
            .catch(function (error) {
            console.log(error);
            })
            .then(function () {
            // always executed
            //console.log("Made request axios ticket to get sites");
            mainObject.showLoader = false;
            console.log("Done");
            mainObject.idEmployee = mainObject.adminSelectedUser;

            }); 


        },

        getNewTicketsSetActiveTicket : function(idTicket)
        {
            console.log("Reload ticket set active idTicket :"+idTicket);
            var mainObject = this;
            mainObject.categoryChanged();
            // CALL To get all tickets for site and department
            axios.get(localStorage.getItem('ticketCopURL') +'/viewSelectedTickets', {
            params: {
                    idTicketCategory : mainObject.selectedCategory,
                    idSite : mainObject.selectSite
            },
             headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
                //console.log(response.data);
                //console.log("getting tickets.."+response.data.length);
                if ( response.data != "error" && response.data.length > 0)
                {
                    response.data.forEach(ticket => {
                        //console.log(ticket.Description[0]);
                        let length = 100;
                        if ( ticket.Description[0].length > length )
                            ticket.ShortDesc =  ticket.Description[0].substring(0, length-3)+"...";
                        else
                            ticket.ShortDesc = ticket.Description[0];
                        for( var i = 0 ; i < mainObject.subCategoryList.length ;i++ )
                        {
                            if ( ticket.idTicketSubCategory == mainObject.subCategoryList[i].idTicketSubCategory )
                            {
                                mainObject.subCategoryList[i].count++;

                            }
                        }
                        //console.log("Done with"+ticket.idTicket);
                    });
                    // console.log("Done tickets..");
                    mainObject.tickets = response.data;
                    mainObject.selectedticket = -1;
                    mainObject.selectTicketWidth = mainObject.$refs.ticketSelect.clientWidth;
                    mainObject.loadingTickets = false;
                }
                else
                {
                    console.log("Error or no tickets here");
                     mainObject.tickets = [];
                }

                
                //mainObject.ticketTagSubCategory_visible = true;

                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    console.log("Got all tickets ");
                    mainObject.selectedticket = idTicket;
                    mainObject.selectedComment = mainObject.selectedTicketComments[0].idTicketHistory;
                    mainObject.createComment = false;
                    console.log("Set selected comment to "+mainObject.selectedComment);

            })
            // END OF AXIOS Call*/

        }


       
          
          
  },
  computed: {

    currentTicket : function()
    {
        var self = this;
        let ticket = [];
        ticket =  self.tickets.filter(function (ticket) {
        if ( ticket.idTicket == self.selectedticket )
        {  
           return true;
        }
        else
        {
            return false;
        }
      })
      if ( ticket.length > 0 )
        return ticket[0];
      else

        return 'None';

    },
    selectedEmployee : function()
    {
        var self = this;
        let user = [];
       
        user =  self.users.filter(function (user) {
        if ( user.idEmployee == self.selectedUser )
        {  
           return true;
        }
        else
        {
            return false;
        }
      })
      if ( user.length > 0 )
        return user[0];
      else

        return 'None';

    },

    selectedTicketComments : function () {
      var self = this;
      let commentList = [];
      commentList =  self.tickets.filter(function (ticket) {
        if ( ticket.idTicket == self.selectedticket )
        {  
           return true;
        }
        else
        {
            return false;
        }
      })
      //console.log("ticketList length = "+commentList.length);
      
      if ( commentList.length > 0 )
      {
          self.commentLength = commentList[0].comments.length;
          return commentList[0].comments;

      }
      else
      {
          self.commentLength = 0;
          return [];

      }
      
    },

    filteredTickets : function ()
    {
        var self = this;
        let tickets = [];
        tickets =  self.tickets.filter(function (ticket) {
            // do not filter by sub category
            if (self.selectedSubCategory == -1 )
            {
                return true;
            }
            else
            {
                // filter by subcategory
                if ( ticket.TicketSubCategory == self.selectedSubCategory )
                    return true;
                else
                    return false;
            }
        })
        return tickets;
    },
    filteredCategory : function ()
    {
        var self = this;
        let cats = [];
        cats =  self.categoryList.filter(function (cat) {
            // do not filter by sub category
            
                // filter by subcategory
            if ( cat.idDepartment== self.selectedStage )
                return true;
            else
                return false;

        })
        return cats;
    },
    searchTicket : function() {
     var self = this;
        let ticketList = [];
        ticketList =  self.searchTicketList.filter(function (ticket) {
            // do not filter by sub category
            if (self.searchField )
            { 
                // filter by subcategory
                //let match = "/"+self.searchField+"/g";
                //if ( (ticket.Description.toLowerCase().match(match).length > 0) )
                if (  (ticket.Description.toLowerCase().includes(self.searchField) ) || (ticket.idTicket.toString().includes(self.searchField) ) )
                    return true;
                else
                    return false;
            }
            else
                return false;

        })
        self.selectedSearchTicket = -1;
        return ticketList;
    }

  },
  
    mounted () {
        EventBus.$on('CLICKED_TICKET', (payload) => {
        this.getTicket(payload.idTicket,payload.idComment);
        })
    },
    created: function () {
        var mainObject = this;
        var idEmployee = localStorage.getItem('idemployee');
        mainObject.idEmployee = idEmployee;
       
        var logger = localStorage.getItem('employee');
        mainObject.logger = logger;
        
        //var idEmployee = localStorage.getItem('idemployee');
        //mainObject.idEmployee = idEmployee;
        mainObject.ActualDate = moment().toISOString();
        // get all tags employee
        let sinceDate = moment().subtract(mainObject.nrDaysTagsToGet,'days').format('YYYY-MM-DD');
        axios.get(localStorage.getItem('ticketCopURL') +'/getTagsEmployee', {
          params: {
              idEmployee : mainObject.idEmployee,
              sinceDate : sinceDate

          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          //console.log(response);
          if ( response.data != "error" )
          //mainObject.sites = response.data;
          response.data.forEach(el => {
               mainObject.timeSlots.push({ Date : el.ActualDate , TicketDescription : el.TicketDescription, TagCategory : el.TagCategory,TagSubCategory : el.TagSubCategory,Value : el.valueAny });
          });
         
          //mainObject.ticketTagSubCategory_visible = true;

        })
        .catch(function (error) {
          console.log(error);
        })
        .then(function () {
          // always executed
          //console.log("Made request axios ticket to get sites");
          mainObject.showLoader = false;
        }); 

        // get all users
        axios.get(localStorage.getItem('ticketCopURL') +'/getUsers', {
          params: {

          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          //console.log(response);
          if ( response.data != "Error" )
          mainObject.users = response.data.users;
          mainObject.selectedUser = mainObject.idEmployee;
          mainObject.adminSelectedUser = mainObject.idEmployee;
          //mainObject.selectedUser = response.data.current_user;
         

        })
        .catch(function () {
          //console.log(error);
        })
        .then(function () {
          //console.log("Made request to get users");
        });
         // get all users
        var startTime = moment(); 
        axios.get(localStorage.getItem('ticketCopURL') +'/getAllticketsDescription', {
          params: {

          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
        })
        .then(function (response) {
          console.log("Quick all Tickets");
           var millDiff = moment().diff(startTime, 'mi')
        console.log("Time to get all the ticket summary : "+ millDiff);	
          console.log(response);
          mainObject.gotticketsSearch = true;
          if ( response.data != "error" ) mainObject.searchTicketList = response.data;

        })
        .catch(function () {
          //console.log(error);
        })
        .then(function () {
          //console.log("Made request to get users");
        });
        
        axios.get(localStorage.getItem('ticketCopURL') +'/getSites', {
          params: {
          
          }, headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
            mainObject.sites = response.data;
            //console.log(response);
            
            })
            .catch(function (error) {
            console.log(error);
            })
            .then(function () {
            // always executed
         
        });// end of axios call
        

        // Get departmentsList 
        axios.get(localStorage.getItem('ticketCopURL') +'/getDepartmentTicket', {
          params: {
          
          }, headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
            mainObject.departmentsList = response.data;
           // console.log(response);
            
            })
            .catch(function (error) {
            console.log(error);
            })
            .then(function () {
            // always executed
         
        });// end of axios call

        // Get departmentsList 
        axios.get(localStorage.getItem('ticketCopURL') +'/getDepartmentCategory', {
          params: {
          
          }, headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
            mainObject.categoryList = response.data;
           // console.log(response);
            
            })
            .catch(function (error) {
            console.log(error);
            })
            .then(function () {
            // always executed
         
        });// end of axios call

        // Get departmentsList 
        axios.get(localStorage.getItem('ticketCopURL') +'/getDepartmentTicket', {
          params: {
          
          }, headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
            mainObject.departmentsList = response.data;
            //console.log(response);
            
            })
            .catch(function (error) {
            console.log(error);
            })
            .then(function () {
            // always executed
         
        });// end of axios call



        // check what permissions the login user have
        axios.get(localStorage.getItem('ticketCopURL') +'/getUser', {
          params: {
              idEmployee : mainObject.idEmployee
          
          },
           headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
            //mainObject.sites = response.data;
           //  console.log("Logged In user permissions");
           // console.log(response.data.doTicketTagAdmin);
            mainObject.adminRights = response.data.doTicketTagAdmin;
            
            })
            .catch(function (error) {
            console.log(error);
            })
            .then(function () {
            // always executed
         
        });// end of axios call
        

    }
}
</script>

<style>

  .vdatetime-input {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  /*margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;*/
  border-radius: 4px;
 
  /*box-sizing: border-box;*/
}

div  {
    outline: none;
}

</style>


